"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorLink = exports.StyledErrorList = exports.StyledErrorHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const Link_styles_1 = require("../../Link/Link.styles");
exports.StyledErrorHeader = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;
`;
exports.StyledErrorList = styled_components_1.default.ul `
    list-style: none;
    margin: 0;
    margin-top: ${tokens_1.SIZES[1]};
    padding: 0;
    & li {
        margin: 0;
    }

    & li:not(:last-child) {
        margin-bottom: ${tokens_1.SIZES[1]};
    }
`;
// Reuses CSS but not the JSX from the Link component
exports.StyledErrorLink = styled_components_1.default.a `
    ${Link_styles_1.linkDefaultStyles}

    &:visited {
        ${Link_styles_1.linkVisitedStyles}
    }

    &:active,
    &:hover,
    &:focus {
        ${Link_styles_1.linkFocusHoverStyles}
    }

    /* Ensure focus styling defined here always overrides global styles using more specific selector when using this */
    &:focus&:focus {
        ${Link_styles_1.linkFocusOnlyStyles}
    }
`;
//# sourceMappingURL=ErrorSummary.styles.js.map